import { render, staticRenderFns } from "./PendingApprovalsList.vue?vue&type=template&id=e5a312a2&scoped=true"
import script from "./PendingApprovalsList.vue?vue&type=script&lang=js"
export * from "./PendingApprovalsList.vue?vue&type=script&lang=js"
import style0 from "./PendingApprovalsList.vue?vue&type=style&index=0&id=e5a312a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a312a2",
  null
  
)

export default component.exports